import { StepContainer } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/styled';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { SelectedFiles } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/AddFileStep/SelectedFiles';
import { ClassifierDropZones } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/AddFileStep/ClassifierDropZones';
import { FileWithClassifier } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/AddFileStep/types';
import { DOCUMENT_LIBRARY_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';

interface Props {
	dealId: string;
	setCanButtonProceed: (canButtonProceed: boolean) => void;
	uploadFileData: FileWithClassifier[];
	setUploadFileData: (uploadFileData: FileWithClassifier[]) => void;
}

export const AddFileStep = ({
	dealId,
	setCanButtonProceed,
	uploadFileData,
	setUploadFileData,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	const handleProcessFile = ({
		dealClassifierId,
		files,
		classifierName,
	}: {
		dealClassifierId?: string;
		files: File[];
		classifierName?: string;
	}) => {
		const duplicateFiles = files.filter((file: File) =>
			uploadFileData.some((uploadedFile) => uploadedFile.file.name === file.name)
		);

		if (duplicateFiles.length > 0) {
			showToastV2({
				title: tCapManage('document.upload_state.uploaded_section.errors.same_name.title'),
				message: `${tCapManage('document.upload_state.uploaded_section.errors.same_name.message')}: ${duplicateFiles.map((file: File) => file.name).join(', ')}`,
				state: 'error',
			});
			throw new Error(tCapManage('document.errors.duplicate-file-upload'));
		}

		const filesWithClassifierId: FileWithClassifier[] = files.map((file: File) => ({
			file,
			dealClassifierId,
			classifierName,
		}));

		setUploadFileData([...filesWithClassifierId, ...uploadFileData]);

		setCanButtonProceed(true);

		setTimeout(() => {
			const selectedFilesHeader = document.querySelector(
				'[aria-describedby="docs-modal-body"]'
			);
			if (selectedFilesHeader) {
				selectedFilesHeader.scrollTo({
					top: selectedFilesHeader.scrollHeight,
					behavior: 'smooth',
				});
			}
		}, 500);
	};

	return (
		<StepContainer data-testid={DOCUMENT_LIBRARY_ELEMENT_ID.UPLOAD_ADD_FILES_STEP}>
			<ClassifierDropZones dealId={dealId} handleProcessFile={handleProcessFile} />
			<SelectedFiles uploadFileData={uploadFileData} setUploadFileData={setUploadFileData} />
		</StepContainer>
	);
};
